<section class="pd30 backGray10">
    <div class="cw">
        <h4 class="centertext gray-2"> Enseña en Predyc </h4>
        <p class="ft16 gray-7 centertext gray-5">Lleva tu trabajo a otros profesionales de la industria.
        <div class="mgt20">
            <img [src]="ensenaPredyc" class="w-100" alt="">
        </div>
    </div>
</section>


<section class="pdt20 pdb30">

    <div class="cw" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8rem">
    
    <!-- ---------------------------------------------------------------------------- Informacion de solicitud -->
    <div fxLayout="column" fxFlex="67%">

        <h6 class="h6Title"> Acerca de Predyc </h6>
        <p>Predyc agrupa a empresas y profesionales independientes que se dedican de manera parcial o en su totalidad a
            brindar servicios de formación en una misma plataforma de capacitación en linea (plataforma web).
        </p>

        <p>Predyc surge de la necesidad de llevar la capacitación industrial a un siguiente nivel.
            El objetivo es proveer un sistema de gestión de aprendizaje LMS (Learning Management System) que permita a
            los usuarios desarrollar las habilidades y conocimientos técnicos a distancia, al ritmo deseado.
        </p>

        <p>
            Permitimos a empresas e independientes ofrecer su material de capacitación (cursos grabados)
            a través de una plataforma especializada de aprendizaje.
        </p>

        <h6 class="h6Title"> A quién esta dirigida Predyc </h6>
        <p>
            Predyc se visualiza para agrupar y ofrecer cursos que proporcionen conocimientos técnicos, científicos y de
            procesos empresariales aplicables al desarrollo de la industria y profesionales de habla hispana que:

            Desempeñan actividades de operación, mantenimiento, confiabilidad, gestión de activos, gerencia, logística y
            compras y recursos humanos.

            Laboren directamente o indirectamente con equipos mecánicos, estáticos, eléctricos, instrumentos y
            industriales relacionados.

            Sean parte de la industria aeronáutica, alimenticia, aluminio, armadoras, autopartes, cementera, cosmética,
            embotelladoras, energética, manufactura, metal mecánica, militar, minería, naval, papel, petroquímica,
            plantas con TPM, plástico, refinerías, siderúrgica y vidrio.
        </p>

        <h6 class="h6Title"> ¿Por qué Predyc? </h6>
        <p>
            <li>Plataforma (software) desarrollado por ingenieros de formación industrial para ingenieros del mismo
                ramo.</li>
            <li>Plataforma Impulsada por Predictiva21 (Revista Digital #1 de Latinoamérica en difusión y capacitación en
                temas de mantenimiento, confiabilidad y gestión de activos.</li>
            <li> Amplia relación comercial existente con empresas e independientes (potenciales clientes).</li>
            <li> Experiencia en marketing digital avanzado, ventas y logística en entrenamiento.</li>
            <li>Equipo motivado, comprometido y apasionado por el sector industrial y la educación, dispuesto a brindar
                todo
                el soporte técnico necesario.</li>
        </p>

        <p class="ft500">Si eres una empresa o profesional independiente que quiere llevar su portafolio de
            capacitación y
            entrenamiento al ambito digital comunicate con nosotros a través de nuestro
            correo
            <span class="ft500 blueLink">contacto@predyc.com</span>
        </p>
    </div>

    <!-- ---------------------------------------------------------------------------- Informacion de solicitud -->
    <div fxFlex="33%">

        <h6 class="h6Title">Solicita un perfil de instructor</h6>
        <form [formGroup]="registerForm" *ngIf="enviado==false" >
            <div>
                <label>Nombre(s) y apellido(s) <span class="red-5">*</span></label>
                <input type="text" formControlName="nombres" class="fw">
            </div>
            <div class="mgt10">
                <label>Resumen profesional <span class="red-5">*</span></label>
                <textarea class="fw" maxlength="5000" formControlName="infoProfesional">
                        </textarea>
            </div>
            <div class="mgt10">
                <label>Empresa</label>
                <input type="text" formControlName="empresa" class="fw">
            </div>
            <div class="mgt10">
                <label>Email <span class="red-5">*</span></label>
                <input type="text" formControlName="email" class="fw">
            </div>
            <div class="mgt10">
                <label>Telefono <span class="red-5">*</span></label>
                <input type="text" formControlName="telefono" class="fw">
            </div>
            <div class="mgt10">
                <label>País<span class="red-5">*</span></label>
                <input type="text" formControlName="pais" class="fw">
            </div>
            <div class="mgt10">
                <label>Título del curso <span class="red-5">*</span></label>
                <input type="text" formControlName="titulo" class="fw">
            </div>
            <div class="mgt10">
                <label>Descripción del curso <span class="red-5">*</span></label>
                <textarea class="fw" maxlength="5000" formControlName="descripcionCurso">
                        </textarea>
            </div>
            <div class="mgt10 fw">
                <button class="grayButton fw"  *ngIf="habilitarEnviar==0">Enviar</button>
                <button class="darkButton fw" *ngIf="habilitarEnviar==1" (click)="enviar()">Enviar</button>

            </div>
        </form>
        <div *ngIf="enviado">
            <p>Solicitud enviada. Un asesor se estará contactando contigo a la brevedad posible. </p>
        </div>
    </div>

    </div>



</section>